<template>
  <AdvertisementForm 
    mode="create" 
    :loading="false" 
    @submit="handleCreate"
    @cancel="$router.push({ name: 'superadmin-tools-advertisement' })"
  />
  
  <!-- Toasts -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4"><div class="font-medium">{{ $t('advertisement.created') }}!</div></div>
  </div>
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4"><div class="font-medium">{{ $t('advertisement.notCreated') }}!</div></div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Toastify from 'toastify-js'
import advertisementApi from '@/services/advertisement/advertisement.api'
import AdvertisementForm from '@/components/advertisement/AdvertisementForm.vue'

const router = useRouter()

const handleCreate = async (payload) => {
  try {
    await advertisementApi.createAdvertisement(payload)
    Toastify({
      node: cash('#success-notification-content').clone().removeClass('hidden')[0],
      duration: 5000, newWindow: true, close: true, gravity: 'top', position: 'right', stopOnFocus: true
    }).showToast()
    router.push({ name: 'superadmin-tools-advertisement' })
  } catch (error) {
    console.error(error)
    Toastify({
      node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
      duration: 10000, newWindow: true, close: true, gravity: 'top', position: 'right', stopOnFocus: true
    }).showToast()
  }
}
</script>